import React from "react";

export default function AnnouncementBar({ cutoff = "14:00" }) {
  const text = `British research laboratory supplier  •  Same-day UK dispatch before ${cutoff}  •  Independently purity tested  •  Tracked next-day delivery  •  For research use only`;
  const items = Array.from({ length: 6 }, (_, i) => i);
  return (
    <div
      className="overflow-hidden border-b"
      style={{
        backgroundColor: "#0B1220",
        borderColor: "rgba(0, 194, 214, 0.18)",
      }}
      data-testid="announcement-bar"
    >
      <div className="pg-marquee-track py-2">
        {items.map((i) => (
          <span
            key={i}
            className="pg-mono text-[10.5px] uppercase tracking-[0.32em] text-[#9CA8B8] px-8 whitespace-nowrap"
          >
            {text}
            <span className="text-[#A6FF00] mx-3">●</span>
          </span>
        ))}
      </div>
    </div>
  );
}
